import * as urlUtils from 'utils/Url';


export function getPathControlUsers(qs={}) {
  return urlUtils.appendQueryString(`/control/users`, qs);
}

export function getPathControlUserDetails(userId) {
  return `/control/users/${userId}/details`;
}

